import { Component, EventEmitter, Input, Output } from '@angular/core';
import { hd } from '@nx-fe/services';
import { AttachmentActivity, EmailAttachment } from 'xsmodules/ticket/ticket.model';

export interface AttachmentEventData {
  attachment: any;
}

@Component({
  selector: 'xs-attachment-menu',
  templateUrl: './attachment-menu.component.html',
  styleUrls: ['./attachment-menu.component.scss'],
})
export class AttachmentMenuComponent {
  /** The list of attachment already addde in the activity */
  @Input()
  attachmentList: string | AttachmentActivity[];
  /** raise an event when an attachment is selected */
  @Output()
  onSelect = new EventEmitter<EmailAttachment>();
  /** comma-separated file type selection, which can be either empty or a valid html 'accept' attribute value (i.e. 'image/*', 'video/*', '.png', etc) */
  @Input()
  fileSelectionType: string;
  /** attachment menu title */
  @Input()
  menuTitle: string;

  public onSelectedFile(event) {
    const attachmentObj: EmailAttachment = {
      fileObj: { file: event.target.files[0], invalidFiles: null },
      attachment: null,
    };
    this.onSelect.emit(attachmentObj);
    event.target.value = null
  };


  public onSelectedAttachment(attachment: AttachmentActivity) {
    const attachmentObj: EmailAttachment = {
      fileObj: null,
      attachment: attachment,
    };
    this.onSelect.emit(attachmentObj);
  }

  public isAttachmentListEmpty(): boolean {
    if (!this.attachmentList) {
      return true;
    }
    if (this.attachmentList && this.attachmentList.length === 0) {
      return true;
    }
    return false;
  }
}
